import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import { EmissionValueWithSuffix } from '../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { CountryCodeToLabelMap } from '../../../../../../../../../../../../shared/helpers/country-region-helpers';
import { DeclaredUnit } from '../../../../../../../../../../../../shared/interfaces/IComponentDetails';
import {
  EmissionSymbol,
  ICalculationDetails,
} from '../../../../../../../../../../../../shared/interfaces/IFootprint';
import styles from '../../CalculationDetails.module.css';

type ElectricityCardProps = {
  calculationDetails?: ICalculationDetails;
};

const ElectricityCard = ({ calculationDetails }: ElectricityCardProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('p-4 border-round-2xl flex w-full flex-column gap-5', styles['card'])}
    >
      <h5 className='p-0 m-0 font-medium'>
        {t('calculationDetailsPage.sections.electricity.title')}
      </h5>

      <div className='grid w-full grid-nogutter'>
        {/* Tarif or Custom Name */}
        <div className='col-6 flex flex-column gap-1 pr-2'>
          <span className='text-gray-700 font-medium'>
            {t('calculationDetailsPage.sections.electricity.tarifOrCustomName')}
          </span>
          {/* Use country & year if name is not available */}
          {calculationDetails?.use_of_energy?.name ? (
            <span className='text-lg'>{calculationDetails?.use_of_energy?.name}</span>
          ) : (
            <span className='text-lg'>
              {calculationDetails?.use_of_energy?.countryCode &&
                CountryCodeToLabelMap[
                  calculationDetails?.use_of_energy?.countryCode as string
                ]}{' '}
              | {calculationDetails?.use_of_energy?.year}
            </span>
          )}
        </div>

        {/* Source */}
        <div className='col-6 flex flex-column gap-1 pl-2'>
          <span className='text-gray-700 font-medium'>
            {t('calculationDetailsPage.sections.electricity.source')}
          </span>
          <span className='text-lg'>{calculationDetails?.use_of_energy?.source}</span>
        </div>
      </div>

      <div className='grid w-full grid-nogutter'>
        {/* Emission Factor */}
        <div className='col-6 flex flex-column gap-1 pr-2'>
          <span className='text-gray-700 font-medium'>
            {t('calculationDetailsPage.sections.electricity.emissionFactor')}
          </span>
          <div className='flex flex-row gap-1 text-lg'>
            <EmissionValueWithSuffix
              emissionValue={calculationDetails?.use_of_energy?.emissionFactor}
              declaredUnit={DeclaredUnit.kilowattHour}
              unitaryProductAmount={1}
              emissionSymbol={EmissionSymbol.G_CO2E}
              abbreviateUnit={true}
              emissionValueDecimals={6}
              suffixTextClassName='font-normal'
              numericalValueTextClassName='font-normal'
            />
          </div>
        </div>
      </div>

      {/* Comment */}
      {calculationDetails?.use_of_energy?.comment && (
        <div className='flex flex-column gap-1 w-full'>
          <span className='text-gray-700 font-medium'>
            {t('calculationDetailsPage.sections.electricity.comment')}
          </span>
          <span
            style={{
              overflowWrap: 'break-word',
            }}
          >
            {calculationDetails?.use_of_energy?.comment}
          </span>
        </div>
      )}
    </div>
  );
};

export default ElectricityCard;
